/**
 * Page size requested from the diagnostic-codes search API (`GET /icd-codes`).
 *
 * The backend defaults to `limit=10` and applies NO ordering and NO relevance
 * ranking, so a broad term returns an arbitrary 10 of the matching rows and the
 * UI has no way to page past them (SUP-20024). Measured against prod:
 * `q=pneumonia` matches 78 codes and "Pneumonia, unspecified organism" (J189) is
 * match #58 — so 10, 25 and even 50 all leave it unreachable. The widest
 * named-disease term measured was `q=failure` at 118 matches.
 *
 * 200 covers every measured named-disease search with headroom. It cannot cover
 * generic single words (`q=unspecified` matches 23,711 of ~74,000 codes) — those
 * need ranking, not a bigger window.
 */
export const ICD_CODE_SEARCH_LIMIT = 200;

export default class IcdCode {
  id: number;
  code: string;
  description: string;
  grouping: string;

  constructor(
    id: number,
    code: string,
    description: string,
    grouping: string = ""
  ) {
    this.id = id;
    this.code = code;
    this.description = description;
    this.grouping = grouping;
  }
}



// WEBPACK FOOTER //
// ./src/models/codes/IcdCode.ts